<div class="existing-account-container">
  <div class="logo">
    <kp-reflect-animation [skipIntro]="false"></kp-reflect-animation>
  </div>
  <h2 class="text title">Welcome to {{ productName }}!</h2>
  <p class="text description">
    It looks like you've used Purposeful or Resourceful before, so you already have a Kumanu account. Simply sign in
    with the same email and password to get started.
  </p>
  <p class="text description">Note: If you signed up with Google or Apple, use that to sign in.</p>
  <ng-container *ngIf="showMobileScreen; else desktop">
    <p class="text description">To get started with the Purposeful app, follow the link below.</p>
    <a class="button button-pill button-app" href="https://kumanu.page.link/open">Go to the Purposeful app</a>
    <p class="text">or</p>
    <div class="button-continue-container">
      <a class="button-continue" routerLink="/login">Continue on the web</a>
    </div>
  </ng-container>
</div>
<p class="text email">
  If you have any trouble, email us at
  <a class="email-link" href="mailto:support@kumanu.com?subject=Help Needed with {{ productName }} Login">
    support@kumanu.com
  </a>
</p>

<ng-template #desktop>
  <a class="button button-pill button-login" routerLink="/login">Sign in</a>
</ng-template>
